module.exports = __webpack_public_path__ + "static/media/logo@3x.e142db11.png";